module.exports = __webpack_public_path__ + "images/arrow-navigation-6213bff9.svg";